import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconLetterASquare: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconLetterASquare"><Path d="M20.5 3.5H3.5V20.5H20.5V3.5Z" stroke="currentColor"/><Path d="M8.35938 16.2275L11.4766 7.77246H12.5195L15.6367 16.2275H14.5293L13.6797 13.8076H10.3164L9.4668 16.2275H8.35938ZM11.9512 9.1377L10.627 12.9111H13.3691L12.0449 9.1377H11.9512Z" fill="currentColor"/></CentralIconBase>;
});

export default IconLetterASquare;
